var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plugin-about-video"},[_c('div',{staticClass:"plugin-about-video__container"},[_c('div',{staticClass:"plugin-about-video__wrapper"},[_c('div',{staticClass:"plugin-about-video__player"},[_c('div',{staticClass:"plugin-about-video__player-content"},[_c('common-video',{attrs:{"video":_vm.video}})],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }